import React, { useState } from "react";
import { Badge } from "react-bootstrap";
import { CommonButton, CommonInput, CommonSelect } from "../Input";
import DataTable from "../table/DataTable";
import CreateRequestModal from "./CreateRequestModal";
import RequestInformationModal from "./RequestInformationModal";

const RequestsList = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    type: null,
    status: null,
  });

  const initialData = [
    {
      id: "297",
      date: "2026-03-10",
      displayDate: "10/03/2026",
      time: "11:18:21",
      type: "Replenishment (Vault to Cash)",
      typeValue: "replenishment",
      amount: "2,000 SGD",
      amended: "No",
      status: "New",
      statusValue: "new",
    },
    {
      id: "296",
      date: "2026-03-09",
      displayDate: "09/03/2026",
      time: "14:22:55",
      type: "Withdrawal (Cash to Vault)",
      typeValue: "withdrawal",
      amount: "5,000 SGD",
      amended: "No",
      status: "In Progress",
      statusValue: "inprogress",
    },
  ];

  const [displayData, setDisplayData] = useState(initialData);

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

  const handleSearch = () => {
    let filtered = initialData.filter((item) => {
      const matchStart = !filters.startDate || item.date >= filters.startDate;
      const matchEnd = !filters.endDate || item.date <= filters.endDate;
      const matchType = !filters.type || item.typeValue === filters.type.value;
      const matchStatus =
        !filters.status || item.statusValue === filters.status.value;
      return matchStart && matchEnd && matchType && matchStatus;
    });
    setDisplayData(filtered);
  };

  const handleReset = () => {
    setFilters({
      startDate: "",
      endDate: "",
      type: null,
      status: null,
    });
    setDisplayData(initialData);
  };

  const columns = [
    { label: "ID", key: "id", className: "ps-4", style: { width: "80px" } },
    {
      label: "Created Date",
      key: "createdDate",
      render: (item) => (
        <div className="fs-12">
          <div className="fw-medium text-black">{item.displayDate}</div>
          <div className="text-muted">{item.time}</div>
        </div>
      ),
    },
    {
      label: "Type",
      key: "type",
      render: (item) => (
        <Badge
          bg="light"
          className="text-primary fw-bold border"
          style={{
            backgroundColor: "#F0F7FF",
            borderColor: "#D0E7FF",
            fontSize: "11px",
          }}
        >
          {item.type}
        </Badge>
      ),
    },
    {
      label: "Amount",
      key: "amount",
      render: (item) => (
        <span className="fw-medium text-black fs-13">{item.amount}</span>
      ),
    },
    {
      label: "Amended",
      key: "amended",
      render: (item) => (
        <Badge
          bg="light"
          className="text-muted px-3 py-1 border rounded"
          style={{ fontSize: "11px", backgroundColor: "#F8F9FA" }}
        >
          {item.amended}
        </Badge>
      ),
    },
    {
      label: "Status",
      key: "status",
      render: (item) => {
        let color = "#667085"; // default Gray
        let bgColor = "#F8F9FA";
        let borderColor = "#EAECF0";

        if (item.statusValue === "new") {
          color = "#344054";
          bgColor = "#F2F4F7";
        } else if (item.statusValue === "inprogress") {
          color = "#B54708";
          bgColor = "#FFFAEB";
          borderColor = "#FEDF89";
        } else if (item.statusValue === "rejected") {
          color = "#B42318";
          bgColor = "#FEF3F2";
          borderColor = "#FECDCA";
        } else if (item.statusValue === "done") {
          color = "#027A48";
          bgColor = "#ECFDF3";
          borderColor = "#ABEFC6";
        }

        return (
          <Badge
            bg="light"
            className="px-3 py-1 border rounded"
            style={{
              fontSize: "11px",
              color: color,
              backgroundColor: bgColor,
              borderColor: borderColor,
            }}
          >
            {item.status}
          </Badge>
        );
      },
    },
    {
      label: "Actions",
      key: "actions",
      className: "pe-4 text-center",
      render: (item) => (
        <button 
          className="btn btn-xs p-0 border-0 bg-transparent text-muted"
          onClick={() => {
            setSelectedRequest(item);
            setShowViewModal(true);
          }}
        >
          <i className="far fa-eye fs-14"></i>
        </button>
      ),
    },
  ];

  const typeOptions = [
    { label: "Replenishment (Vault to Cash)", value: "replenishment" },
    { label: "Withdrawal (Cash to Vault)", value: "withdrawal" },
  ];

  const statusOptions = [
    { label: "New", value: "new" },
    { label: "In Progress", value: "inprogress" },
    { label: "Rejected", value: "rejected" },
    { label: "Done", value: "done" },
  ];

  return (
    <div className="container-fluid">
      <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-2">
        <h2 className="fw-bold text-black mb-0 fs-24">Requests</h2>
        <div className="d-flex flex-wrap align-items-center gap-2">
          <div style={{ width: "150px" }}>
            <CommonInput
              type="date"
              placeholder="Start Date"
              value={filters.startDate}
              onChange={(e) => handleFilterChange("startDate", e.target.value)}
            />
          </div>
          <div style={{ width: "150px" }}>
            <CommonInput
              type="date"
              placeholder="End Date"
              value={filters.endDate}
              onChange={(e) => handleFilterChange("endDate", e.target.value)}
            />
          </div>
          <div style={{ width: "180px" }}>
            <CommonSelect
              placeholder="Select type"
              options={typeOptions}
              value={filters.type}
              onChange={(val) => handleFilterChange("type", val)}
            />
          </div>
          <div style={{ width: "150px" }}>
            <CommonSelect
              placeholder="Select status"
              options={statusOptions}
              value={filters.status}
              onChange={(val) => handleFilterChange("status", val)}
            />
          </div>
          <CommonButton onClick={handleReset} variant="outline">
            <i className="flaticon-381-repeat-1"></i>
          </CommonButton>
          <CommonButton onClick={handleSearch}>
            <i className="flaticon-381-search-1 fs-18 text-white"></i>
          </CommonButton>
          <CommonButton
            className="ms-2 px-4"
            onClick={() => setShowCreateModal(true)}
          >
            <i className="fa fa-plus me-2"></i> Create Request
          </CommonButton>
        </div>
      </div>

      <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={displayData}
            showPagination={false}
            minWidth="100%"
          />
        </div>
      </div>

      <CreateRequestModal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
      />

      <RequestInformationModal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        request={selectedRequest}
      />
    </div>
  );
};

export default RequestsList;
